export const TEAM_ID_TO_NAME = {
  AFG: "Afghanistan",
  AUS: "Australia",
  BGD: "Bangladesh",
  ENG: "England",
  IND: "India",
  NLD: "Netherlands",
  NZL: "New Zealand",
  PAK: "Pakistan",
  ZAF: "South Africa",
  LKA: "Sri Lanka",
};
